import currencyPairCheck from "../../utilities/currencyPairCheck";
import { formatMoney } from "../../utilities/formatMoney";
import dayjs from "dayjs";


export const businessToUse = (order, business, type) => {
    if (type === "inbound") {
        return {
            name: "",
            bizName: order?.outbound?.businessName,
            email: order?.outbound?.email,
            id: order?.outbound?.businessId,
        };
    } else if (type === "outbound") {
        return {
            name: "",
            bizName: order?.inbound?.businessName,
            email: order?.inbound?.email,
            id: order?.inbound?.businessId,
        };
    } else {
        return order?.inbound?.businessId === business?._id
            ? {
                  type: order?.flexUserType ?? "supplier",
                  createdByCurrBiz: order?.business === business?._id ? true : false,
                  name: "",
                  bizName: order?.outbound?.businessName,
                  email: order?.outbound?.email,
                  id: order?.outbound?.businessId,
              }
            : {
                  type: order?.flexUserType === "supplier" ? "buyer" : "supplier",
                  createdByCurrBiz: order?.business === business?._id ? true : false,
                  name: "",
                  bizName: order?.inbound?.businessName,
                  email: order?.inbound?.email,
                  id: order?.inbound?.businessId,
              };
    }
};

export const formatDate = (dateString, format = "D MMM YYYY") => {
    const date = dayjs(dateString);
    if (!date.isValid()) {
        return "N/A";
    }
    if (format === "custom") {
        const day = date.format("Do");
        const month = date.format("MMMM"); 
        const year = date.format("YYYY");
        return `${day} of ${month}, ${year}`;
    }

    return date.format(format);
};

export const isSender = (activeBusinessUserId, invoiceSenderId) => { 
    return activeBusinessUserId === invoiceSenderId;
}

export function validateShippingDetails(details, requiredFields) {
    for (const field of requiredFields) {
        if (!details?.[field] || details?.[field].trim() === "") {
            return { valid: false, message: `${field} is required` };
        }
    }

    return { valid: true, message: "Details are valid" };
}

export function validateArrayOfObjects(ports, requiredFields) {
    for (const port of ports) {
        for (const field of requiredFields) {
            if (!port[field] || port[field].trim() === "") {
                return { valid: false, message: `${field} is required` };
            }
        }
    }

    return { valid: true, message: "Details are valid" };
}

export function calculatePercentagePaid(totalAmount, paidAmount) {
    if (!totalAmount || !paidAmount) return 0;
    if (totalAmount === 0) return 0;
    const evaluatedValue =
       ( parseInt((paidAmount / totalAmount) * 100) > 100)
            ? 100
            : parseInt((paidAmount / totalAmount) * 100);
    return evaluatedValue;
}

export function truncateString(longString) {
    // Extract date from string (assuming it's in the format of timestamp)
    if(!longString) return
    const timestampMatch = longString?.match(/\d{13}/);
    let dateStr = "UnknownDate";
    if (timestampMatch) {
        const timestamp = parseInt(timestampMatch[0].slice(0, 10));
        const date = new Date(timestamp * 1000);
        const month = date.toLocaleString("default", { month: "short" });
        const day = date.getDate();
        dateStr = `${day}${month}`;
    }

    // Extract file extension
    const fileExt = longString.split(".").pop();

    // Extract meaningful words from the string
    const words = longString?.match(/[a-zA-Z]+/g);
    const meaningfulWords = words.filter((word) => word.length > 2);

    // Combine date, meaningful words, and file extension
    const truncatedStr = `${dateStr}-${meaningfulWords.slice(0, 3).join("-")}...${fileExt}`;

    return truncatedStr;
}

export function checkExpiry(expiryDate) {
    const today = new Date();
    const expiry = new Date(expiryDate);

    if (today <= expiry) {
        return "Valid until " + formatDate(expiryDate, "D MMM, YYYY");
    } else {
        return "Expired";
    }
}

export const receiptDownloader = (res, id) => {
    const url = window.URL.createObjectURL(new Blob([res.data]));
    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", `receipt-${id}.pdf`);
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
}

export const currencyToDisplay = (currency, amount, opt) => {
  return (currency === "USDT" || currency === "USDC") ? `${formatMoney(Math.floor(amount))} ${currencyPairCheck(currency)}` : `${currencyPairCheck(currency, opt)} ${formatMoney(Math.floor(amount))}`
}